// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import shoppingCart01Icon from "@/assets/icons/shopping-cart-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ShoppingCart01IconProps = Omit<IconProps, "name">;

export function ShoppingCart01Icon(props: ShoppingCart01IconProps): React.ReactNode {
  return <Icon name={shoppingCart01Icon} {...props} />;
}
